// local mappings
import type { SyntheticVerificationMap } from '../components/SyntheticIdVerification/SyntheticIdVerification.mappings';
import {
    synthReasonMapN,
    synthReasonMapY,
    synthReasonMapU
} from '../components/SyntheticIdVerification/SyntheticIdVerification.mappings';
// Constants and types
import type { ComplianceType, DocumentVerificationTrustReasons } from './types';
import { BinaryValues, completedStatusMap, ComplianceStatus, SyntheticFindingKey, ResendIdRequestStatus } from './types';

export const defineDocTrustReasons = (reasons: string): DocumentVerificationTrustReasons[] =>
    reasons
        ? reasons
              .trim()
              .split(',')
              .map((el) => el.trim() as DocumentVerificationTrustReasons)
        : [];

export const getSyntheticReasons = (findings: { name: string; value: string }[]): SyntheticVerificationMap[] => {
    const validKeys = Object.values(SyntheticFindingKey);

    return findings
        .filter((finding) => validKeys.includes(finding.name as SyntheticFindingKey))
        .map((finding) => {
            let map;
            if (finding.value === BinaryValues.Y) {
                map = synthReasonMapY;
            } else if (finding.value === BinaryValues.N) {
                map = synthReasonMapN;
            } else {
                map = synthReasonMapU;
            }

            return map[finding.name as SyntheticFindingKey];
        })
        .filter(Boolean);
};

export function isValidSection(
    section: any
): section is { type: ComplianceType; component: JSX.Element; status: ComplianceStatus | 'UNKNOWN' } {
    return section !== null && section !== undefined;
}

export const createStatusConfig = (icon: React.ElementType, color: string, label: string, testId: string) => ({
    icon,
    color,
    label,
    testId
});

export const getStatus = (status: string | undefined, TrustValue: BinaryValues): ComplianceStatus | string => {
    if (status === ComplianceStatus.COMPLETED && TrustValue) {
        return completedStatusMap[TrustValue];
    }

    return status ?? '';
};

export function getResendIdRequestState(status: string, trustValue: string) {
    let resendStatus = ResendIdRequestStatus.NotRequested;
    let sendButtonDisabled = false;

    switch (status) {
        case ComplianceStatus.NOT_STARTED:
            resendStatus = ResendIdRequestStatus.NotRequested;
            break;
        case ComplianceStatus.STARTED:
            resendStatus = ResendIdRequestStatus.Started;
            sendButtonDisabled = true;
            break;
        case ComplianceStatus.PASS:
            resendStatus = ResendIdRequestStatus.Completed;
            sendButtonDisabled = true;
            break;
        case ComplianceStatus.FAIL:
            resendStatus = ResendIdRequestStatus.Completed;
            break;
        case ComplianceStatus.COMPLETED:
            resendStatus = ResendIdRequestStatus.Completed;
            sendButtonDisabled = trustValue === BinaryValues.Y;
            break;
        case ComplianceStatus.ERROR:
            resendStatus = ResendIdRequestStatus.Completed;
            break;
        default:
            break;
    }
    return { resendStatus, sendButtonDisabled };
}
